var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.visible? 'visible':'', _vm.statusClass],attrs:{"id":"global-message"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}),(_vm.requiresAcknowledgement)?_c('button',{staticClass:"interactive",on:{"click":_vm.hideMessage}},[_vm._v("OK")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }